import {
  Button,
  Row,
  Col,
  Select,
  Radio,
  Input,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import "../../styles/components.scss";
import { Header } from "../../components/Header";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { getListOfInputs } from "../../utils/APIs";
const { Option } = Select;
const ChoiceDefaultTemplate = ({ showHeader, name, setSelectedChoice }) => {
  const location = useLocation();
  const [selected, setSelected] = useState(2);
  const [value, setValue] = useState("");
  const [id, setId] = useState(-1);
  const [listInputs, setListInputs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getListOfInputs().then((res) => {
      setListInputs(res);
      if (res.length > 0) {
        setId(res[0].id);
        setValue(res[0].name);
        setSelectedChoice(res[0].id);
      }
    });
  }, [location]);

  const onNext = () => {
    if (selected == 1) {
      navigate("/inputs", {
        state: {
          id: -1,
          name: value,
        },
      });
    } else {
      navigate("/inputs", {
        state: {
          id: id,
          name: value,
        },
      });
    }
  };
  return (
    <>
      {showHeader && (
        <>
          <Header />

          <div style={{ textAlign: "center", marginTop: "10vh" }}>
            <Typography.Title level={2} className="roi--title-admin">
              <FormattedMessage id="manageInputsCalculation" />
            </Typography.Title>
          </div>
        </>
      )}

      {showHeader && (
        <>
          <div style={{ marginTop: "4vh" }}>
            <Row gutter={24} style={{ marginRight: "1vh", marginLeft: "1vh" }}>
              <Col md={1} sm={1} style={{ textAlign: "center" }}>
                <Radio
                  value={1}
                  checked={selected == 1}
                  onChange={() => {
                    setSelected(1);
                    setId(-1);
                    setValue("");
                  }}
                ></Radio>
              </Col>
              <Col md={16} sm={16}>
                <span
                  className="roi--label-section"
                  style={{ marginLeft: "1vh" }}
                >
                  <FormattedMessage id="creationDefine" />
                </span>
              </Col>
              <Col md={6} sm={8} className="roi--header-content">
                {id == -1 && (
                  <Input
                    className="roi--input"
                    disabled={selected != 1}
                    value={selected == 1 ? value : ""}
                    onChange={(e) => setValue(e.target.value)}
                    style={{ width: "100%" }}
                  />
                )}
              </Col>
            </Row>
          </div>
          <div style={{ marginTop: "2vh" }}>
            <Row gutter={24} style={{ marginRight: "1vh", marginLeft: "1vh" }}>
              <Col md={1} sm={1} style={{ textAlign: "center" }}>
                <Radio
                  value={2}
                  checked={selected == 2}
                  onChange={() => {
                    setSelected(2);
                    setValue(listInputs[0].name);
                    setId(listInputs[0].id);
                  }}
                ></Radio>
              </Col>
              <Col md={16} sm={16}>
                <span
                  className="roi--label-section"
                  style={{ marginLeft: "1vh" }}
                >
                  <FormattedMessage id="defineTheInputs" />
                </span>
              </Col>
              <Col md={6} sm={8}>
                {id > -1 && (
                  <Select
                    disabled={selected == 1}
                    style={{ width: "100%" }}
                    defaultValue={listInputs.length > 0 && listInputs[0].id}
                    onChange={(e) => {
                      setId(e);
                      setSelectedChoice(e);
                      setValue(listInputs.filter((el) => el.id == e)[0].name);
                    }}
                  >
                    {listInputs.map((element) => (
                      <Option value={element.id}>{element.name}</Option>
                    ))}
                  </Select>
                )}
              </Col>
            </Row>
          </div>

          <div style={{ textAlign: "center" }}>
            <Button
              className="roi--button-primary"
              style={{ marginTop: "4vh", textAlign: "center" }}
              onClick={() => onNext()}
            >
              <FormattedMessage id="next" />
            </Button>
          </div>
        </>
      )}
      {!showHeader && (
        <>
          <Row gutter={24} style={{ marginRight: "1vh", marginLeft: "1vh" }}>
            <Col xl={16} md={16}>
              <span className="roi--label-section">
                <FormattedMessage
                  id="dataToBeDisplayed"
                  values={{ value: name }}
                />
              </span>
            </Col>
            <Col xl={6} md={8}>
              {id > -1 && (
                <Select
                  style={{ width: "100%" }}
                  defaultValue={listInputs.length > 0 && listInputs[0].id}
                  onChange={(e) => setId(e)}
                >
                  {listInputs.map((element) => (
                    <Option value={element.id}>{element.name}</Option>
                  ))}
                </Select>
              )}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default ChoiceDefaultTemplate;
